export interface IAdminInfo {
  userid: number,
  username: string,
  dev_role_id: number,
  avatar: string,
  email: string,
  join_at: number
}

export interface IAdminState {
  adminList: IAdminInfo[]
}

export enum EAdminRole {
  SUPER = 100, // 超级管理员
  GENERAL = 80, // 普通管理员
}
